import { generateMedia } from 'styled-media-query';

export default generateMedia({
  xSmall: '320px', // mobile
  small: '576px', // mobile
  medium: '768px', // tablet - portrait mode
  large: '1024px', // tablet - landscape mode
  mLarge: '1280px', // laptop
  xLarge: '1440px', // desktop
  x2Large: '1680px',
  x3Large: '1920px' // desktop
});
